import React, { FC } from 'react';

export const MagicLinkSvg: FC<{}> = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <defs>
      <path
        id="a"
        d="M0.000388888889 0.351944444L11.8801111 0.351944444 11.8801111 12.2222222 0.000388888889 12.2222222z"
      ></path>
    </defs>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-1057 -647) translate(1057 647) translate(0 6.925)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a"></use>
        </mask>
        <path
          fill="#FFF"
          d="M3.19 10.21L2.011 9.033l4.715-4.714 1.179 1.178-4.715 4.715zm5.5-7.856L9.87 3.533l-.787.785L7.905 3.14l.785-.785zm3.19 1.179a.838.838 0 00-.243-.59L9.279.586a.859.859 0 00-1.179 0L.245 8.443a.834.834 0 000 1.179L2.6 11.978a.831.831 0 001.178 0l7.858-7.856a.837.837 0 00.243-.59z"
          mask="url(#b)"
        ></path>
      </g>
      <path
        fill="#FFF"
        d="M13.078 5.792h.278v.277a.834.834 0 001.667 0v-.277h.278a.834.834 0 000-1.667h-.278v-.278a.834.834 0 00-1.667 0v.278h-.278a.834.834 0 000 1.667M2.865 6.577h.277v.278a.834.834 0 001.667 0v-.278h.278a.834.834 0 000-1.667h-.278v-.277a.834.834 0 00-1.667 0v.277h-.277a.834.834 0 000 1.667M14.515 14.339h-.278v-.278a.834.834 0 00-1.666 0v.278h-.278a.834.834 0 000 1.666h.278v.278a.834.834 0 001.666 0v-.278h.278a.834.834 0 000-1.666M18.314 9.821h-2.356a.834.834 0 000 1.667h2.356a.834.834 0 000-1.667M8.493 4.023c.46 0 .834-.373.834-.833V.833a.834.834 0 00-1.667 0V3.19c0 .46.373.833.833.833"
        transform="translate(-1057 -647) translate(1057 647)"
      ></path>
    </g>
  </svg>
);
